import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useTable, useSortBy } from "react-table";

import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import PaginationAndSearching from "../../components/Pagination Component/paginationAndSearching";
import SkeletonTableRow from "../../components/SkeltonTable/skeletonTable";

export const UserTable = ({
  column,
  rowsArr,
  handleVerify,
  handleSearchPagination,
  searchValuePagination,
  pageSizePagination,
  handleChangeRowsPerPagePagination,
  totalCountPagination,
  handleOnChangePagination,
  showLoading,
  handleDeleteById,
  handleTabExpanded,
  userArr,
  handleActionMultipleApprove,
  handleSeeVendor,
  handleEditVendor,
  selectedRows,
  setSelectedRows,
  onLoadData
}) => {
  const {permissionArr} = useSelector(state =>state.auth)
  const dispatch = useDispatch()
  const columns = useMemo(() => column, []);
  const data = useMemo(() => rowsArr, [rowsArr]);
  const userData = useMemo(() => userArr, [userArr]);
  const [checkedRows, setCheckedRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const tableInstance = useTable({ columns, data }, useSortBy);
useEffect(()=>{},[userArr])
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    //footerGroups,
    rows,
    prepareRow,
  } = tableInstance;
 
 
 

 const getId =useCallback( (row) => {
    const id = row.original.Id;

    if (selectedRows?.find(item => item.Id === id)) {
      setSelectedRows(selectedRows.filter(item => item.Id !== id));
    } else {
      setSelectedRows([...selectedRows, row.original]);
    }
    console.log(selectedRows)
  }, [selectedRows, setSelectedRows]);
  



  return (
    <>

      <div className="card">
        <div className="card-header">
     
        <div className="d-flex justify-content-end" style={{width:'100%'}}>
            <div className="service-input-group input-group" style={{width:"220px"}}>
                        <span className="input-group-text search-input-icon">

                            <i className="bi bi-search" style={{ fontSize: '16px' }}></i>
                        </span>
                        <input
                            type="text"
                            className="form-control search-input"
                            id="val-username1"
                            placeholder="Search..."
                            name="username"
                            value={searchValuePagination}
                            onChange={handleSearchPagination}
                        />
                    </div>
            </div>
        </div>
        <div className="card-body">
          <div className="table-responsive">
            <div className="dataTables_wrapper">
              <table {...getTableProps()} className="table dataTable display" style={{zoom:'0.9'}}>
             {!showLoading && <>
              <thead>
                  {headerGroups.map((headerGroup) => (
                    <tr {...headerGroup.getHeaderGroupProps()}>
                      {headerGroup.headers.map((column) => (
                        <th
                          {...column.getHeaderProps(
                            column.getSortByToggleProps()
                          )}
                          style={{ color: "rgba(23, 90, 169, 0.78)" }}
                        >
                          {column.render("Header")}
                          <span className="ml-1">
                            {column.isSorted ? (
                              column.isSortedDesc ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>
             
                <tbody {...getTableBodyProps()}>
                  {rows.map((row, rowIndex) => {
                    prepareRow(row);
                    return (

                      <>
                       <tr {...row.getRowProps()}>
                        {row.cells.map((cell, cellIndex) => {
                      const firstCol = cellIndex === 0;
                    
                    
                      // {console.log(cell.render("Cell") )}

                          return (

                            
                          
                            
                            <td
                              {...cell.getCellProps()}
                              style={{ color: "black" ,whiteSpace:'normal' }}
                            >

                              {
                                firstCol ? (
                                
//                                 <div>
//  <OverlayTrigger
//                                         placement="top"
//                                         overlay={
//                                           <Tooltip id="tooltip">{"Active"}</Tooltip>
//                                         }
//                                       >
//                                         <i
//                                           className="material-icons"
//                                           style={{
//                                             color: "orange",
//                                             marginRight: "6px",
//                                             cursor: "pointer",
//                                           }}
//                                           onClick={() => {
//                                             handleEditVendor(
                                              
//                                               rows[rowIndex].original
//                                             );
//                                           }}
//                                         >
//                                           edit
//                                         </i>
//                                       </OverlayTrigger>
//                                 </div>
                              
                   
                                <div>
        <input
                                        type="checkbox"
                                        checked={selectedRows?.find(item => item.Id === row.original.Id)}
                                        onChange={() => getId(row)}
                                      />
                                </div>
                              ):(
                              <div>
                                  { cell.render("Cell") }
                                </div>
                             )
                              } 
                         
                         
                       
                           
                            </td>
                          );
                        })}

                      </tr>
                    
                      </>
                     

                      
                      
                    );
                  })}
                </tbody></>}
             {showLoading &&   <SkeletonTableRow cols={4} row ={4}/>}
                {/* This is only for footer if u require */}
              </table>

              {rows.length === 0 && (
                <div style={{ display: "flex", justifyContent: "center" }}>
                  No record found
                </div>
              )}

            </div>
          </div>
          
<PaginationAndSearching
                  handleSearch={handleSearchPagination}
                  searchValue={searchValuePagination}
                  defaultValue={pageSizePagination}
                  handleChangeRowsPerPage={handleChangeRowsPerPagePagination}
                  totalCount={totalCountPagination}
                  onChange={(e,p)=>{
                    handleOnChangePagination(e,p)
                    // setCheckedRows([])
                  }}
                />
             
        </div>
      </div>
    </>
  );
};
export default UserTable;
